import {
    ApDropdown,
    ApDropdownItem,
} from '@uipath/portal-shell-react';
import React, {
    useEffect,
    useState,
} from 'react';
import type { ControllerRenderProps } from 'react-hook-form';
import { useIntl } from 'react-intl';

import type { ByoLlmConfiguration } from '../../../../services/llm-gateway/LlmGateway.types';
import { ApiFlavor } from '../../../../services/llm-gateway/LlmGateway.types';
import type { AddEditConfigurationFormData } from '../AddEditConfigurationViewModel';

interface LlmApiFlavorProps {
    value?: string;
    disabled?: boolean;
    availableApiFlavors?: ApiFlavor[];
    llmConfigurationsField: ControllerRenderProps<AddEditConfigurationFormData, 'llmConfigurations'>;
    notifyFieldChanges: () => void;
    desiredModel: string;
    llmConfiguration: Partial<ByoLlmConfiguration>;
}

export const LlmApiFlavorDropdown: React.FC<LlmApiFlavorProps> = ({
    value,
    disabled,
    availableApiFlavors,
    llmConfigurationsField,
    notifyFieldChanges,
    desiredModel,
    llmConfiguration,
}) => {
    const { formatMessage: translate } = useIntl();
    const [ selectedValue, setSelectedValue ] = useState<string | undefined>(value);

    const apiFlavors = availableApiFlavors ?? Object.values(ApiFlavor);

    useEffect(() => {
        setSelectedValue(value);
    }, [ value ]);

    return (
        <ApDropdown
            style={{ width: '350px' }}
            label={translate({ id: 'CLIENT_LLM_API_FLAVOR' })}
            selectedValue={selectedValue}
            onSelectedValueChanged={(event: CustomEvent) => {
                const newValue = event.detail as ApiFlavor;
                setSelectedValue(newValue);

                const updatedConfiguration: Partial<ByoLlmConfiguration> = ({
                    ...(llmConfiguration),
                    apiFlavor: newValue,
                });

                llmConfigurationsField.onChange({
                    ...llmConfigurationsField.value,
                    [desiredModel]: updatedConfiguration,
                });
                notifyFieldChanges();
            }}
            disabled={disabled}
            required
            data-cy='llm-api-flavor-dropdown'>
            {apiFlavors?.map((flavor) => (
                <ApDropdownItem
                    key={flavor}
                    value={flavor}
                    label={flavor}
                />
            ))}
        </ApDropdown>
    );
};
